import { create } from "zustand";

import { withSelectors } from "Utilities/Zustand/withSelectors";

import { contentKeys } from "./contentKeys";

const store = create((set) => ({
  activeContentKey: contentKeys.nothing,
  setActiveContentKey: (key) => {
    if (Object.values(contentKeys).includes(key)) {
      set({ activeContentKey: key });
    }
  },

  clickAwayDisabled: false,
  setClickAwayDisabled: (value) => {
    set({ clickAwayDisabled: value });
  },

  verticallyCenterLogin: false,
  setVerticallyCenterLogin: (value) => {
    set({ verticallyCenterLogin: value });
  },

  callbackAfterLogin: null,
  setCallbackAfterLogin: (value) => {
    set({ callbackAfterLogin: value });
  },
}));

export const useMemberToolbarStore = withSelectors(store);
